import Keycloak from 'keycloak-js';

// Initialize Keycloak instance with the Keycloak configuration URL and realm/client details
const keycloak = new Keycloak({
  url: process.env.REACT_APP_KEYCLOAK_URL,
  realm: process.env.REACT_APP_REALM,
  clientId: process.env.REACT_APP_CLIENT_ID,
});
export default keycloak;

// Start a social login directly from a public page (e.g. signup) by redirecting
// to Keycloak's authorize endpoint with `kc_idp_hint`, so the Keycloak username
// screen is skipped and the user lands straight on the chosen provider. On the
// return to /login the AuthProvider's keycloak-js flow completes the code
// exchange (using the SSO session Keycloak just established) and runs the
// federated provisioning. `alias` is the Keycloak IdP alias, e.g. 'google',
// 'facebook', 'linkedin-openid-connect'.
export const loginWithIdp = (alias) => {
  const base = (process.env.REACT_APP_KEYCLOAK_URL || '').replace(/\/$/, '');
  const realm = process.env.REACT_APP_REALM;
  const params = new URLSearchParams({
    client_id: process.env.REACT_APP_CLIENT_ID,
    redirect_uri: `${window.location.origin}/login`,
    response_type: 'code',
    scope: 'openid',
    kc_idp_hint: alias,
  });
  window.location.href = `${base}/realms/${realm}/protocol/openid-connect/auth?${params.toString()}`;
};
